import React from 'react';
import {Space} from 'antd';
import {Bubble} from '@ant-design/x';
import {AnimatePresence} from 'framer-motion';
import ScaleFade from '../animations/ScaleFade';
import {AgentChatMessageContent} from './AgentChatMessageContent';

const roles = {
  assistant: { placement: 'start' },
  user: { placement: 'end' },
};

/**
 * Scrollable list of agent-chat message bubbles. Shared between the
 * drawer/embedded AgentChat and the full-width chat — each passes in its
 * own styled components so the visuals stay independent.
 */
export const AgentChatMessageList = ({
  messages,
  parseMessage,
  onSend,
  selectedOptions,
  onToggleOption,
  onSubmitOptions,
  Confirmation,
}) => (
  <AnimatePresence initial={false}>
    <Space style={{width: '100%'}} direction='vertical' size='middle'>
      {messages.map((message, idx) => (
        <ScaleFade key={idx}>
          <Bubble
            className={message.type && `bubble-${message.type}-message`}
            content={(
              <AgentChatMessageContent
                message={message}
                idx={idx}
                allMessages={messages}
                parseMessage={parseMessage}
                onSend={onSend}
                selectedOptions={selectedOptions}
                onToggleOption={onToggleOption}
                onSubmitOptions={onSubmitOptions}
                Confirmation={Confirmation}
              />
            )}
            role={message?.role}
            key={message?.id}
            placement={roles[message?.role]?.placement || 'start'}
          />
        </ScaleFade>
      ))}
    </Space>
  </AnimatePresence>
);
